export const DsDividerDefaultProps = {
    'ds-size': 'M'
};
